<template>
  <p class="price">
    <strong class="price__value">{{ price }}</strong>
    <span class="price__tax">{{ secondLine }}</span>
  </p>
</template>

<script>
export default {
  name: 'Price',
  props: ['price', 'secondLine']
};
</script>

<style lang="scss" scoped>
/**
 * Price
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Price, tax and shipping component
 * @since 2020-10-26
**/

$component: 'price';

.#{$component} {
  margin: 0;
  text-align: left;

  &__value {
    display: block;
    @include margin-bottom(- map-get($spacers, 1));
    @include font-size(map-get($proposal-page, 'font-size-xl'));
    font-weight: $font-weight-bolder;
  }

  &__tax {
    display: block;
    @include font-size(map-get($proposal-page, 'font-size-sm'));

    &,
    a {
      color: $ink-lightest;
    }

    a {
      text-decoration: underline;
    }

  }
}
</style>
